import React from 'react';

const FAQS = [
  {
    q: 'What counts as a "credit"?',
    a: 'Every skill run consumes credits based on its risk tier and cost — a low-risk content skill costs less than a scripted, sandboxed action. Credits reset each billing period and unused credits roll over for up to one period.',
  },
  {
    q: 'Do you support single sign-on (SSO)?',
    a: 'SSO/SAML is on our Enterprise roadmap. Today the control plane uses email/password with JWT sessions. Admin, Operator, and Viewer roles are assigned per user and enforced on every write endpoint.',
  },
  {
    q: 'Can I bring my own project management tool?',
    a: 'Yes — the platform natively syncs with Plane, GitHub, and Slack today, with a Zapier MCP bridge for thousands of other apps. Asana, Monday, and Trello connectors are in progress.',
  },
  {
    q: 'What happens if I exceed my included credits?',
    a: 'You can enable overage billing at a per-tier rate, or we\'ll notify your workspace admin so you can upgrade before agents are throttled — your choice, configured per workspace.',
  },
  {
    q: 'Is there a free trial?',
    a: 'No — self-serve plans (Starter/Growth/Scale) are billed immediately at checkout via Stripe. Enterprise plans include a guided pilot with our team before any contract is signed.',
  },
];

export default function FaqSection() {
  return (
    <section className="lp-faq" id="faq">
      <div className="lp-section__head">
        <p className="lp-eyebrow">FAQ</p>
        <h2>Questions, answered</h2>
      </div>
      <div className="lp-faq__list">
        {FAQS.map((f) => (
          <details className="lp-faq__item" key={f.q}>
            <summary>{f.q}</summary>
            <p>{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
